export class CatalogEntryQuestionApi
{
    questionId: number;
    questionGuid: string;
    questionFr: string;
    questionEn: string;
    endpointGuid: string;
    definition: any;
    type: string;
    condition: string;
    mandatory: boolean;
}
